import { App, AppFeatures } from '@playq/octopus2-apps';

export const getFavoriteFiled = ({ features, app }: { features: Record<string, AppFeatures>; app: App }) => {
  return features[app.id.serialize()]?.isFavourite;
};
